import Amount from './amount';
import Details from './details';
import Payment from './payment';
import Thanks from './thanks';

export default {
  Amount,
  Details,
  Payment,
  Thanks
};
